var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineTrushSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.829 9.8c-3.46-.34-6.9-.48-10.31-.13l-1.34.13a.745.745 0 0 1-.82-.67.75.75 0 0 1 .67-.82l1.34-.13c3.51-.35 7.05-.22 10.61.13.41.04.71.41.67.82-.04.38-.37.67-.75.67h-.07z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.55 8.52-.14-.85c-.02-.14-.06-.36-.1-.41-.067-.04-.22-.06-.46-.06h-1.72l-.47.06c-.02.04-.06.26-.08.4l-.14.86a.76.76 0 0 1-.86.62.76.76 0 0 1-.62-.86l.14-.86c.11-.64.29-1.71 2.03-1.71h1.72c1.75 0 1.93 1.12 2.03 1.72l.14.85c.07.41-.21.8-.61.86h-.12a.75.75 0 0 1-.74-.62z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89 18.31c-2.53 0-2.64-1.52-2.71-2.53l-.43-6.61a.75.75 0 1 1 1.5-.1l.43 6.6c.07.98.08 1.13 1.21 1.13h4.21c1.13 0 1.14-.15 1.21-1.13l.43-6.6c.03-.41.37-.73.8-.7.41.03.73.38.7.8l-.43 6.6c-.07 1.02-.17 2.54-2.71 2.54H9.89z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTrushSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-trush-square.48aeb6a7ca15795b485f623e15490970.svg";
export { ForwardRef as ReactComponent };